'use client';
import Image from 'next/image';
import { DATA_STATUS, NOTICE } from '@/shared/utils/const';
import { useNoticeData } from '@/features/notice/hook/useNoticeData';
import { formatDateTimeStringToKoreaTimeString } from '@/shared/utils/datetimes';
import { useT } from '@/shared/i18n/I18nProvider';

export const NoticeList = () => {
  const { allNotifications, lastElementRef, handleReadOne } = useNoticeData(null);
  // Provider에서 가져옴
  const t = useT();

  return (
    <>
      <ul className="notice-scroll pc-scrollbar">
        {allNotifications.map((item, index) => (
          <li
            key={item.id_noti}
            ref={index === allNotifications.length - 1 ? lastElementRef : undefined}
            className="mo-notice-list-item"
          >
            <button onClick={() => handleReadOne(item)}>
              <dl className={`${item.yn_read === 'N' ? 'active' : ''}`}>
                <dt className="flex items-center justify-between">
                  <p className="inline-flex gap-[8px]">
                    <span className="act-symbol">{`[${item.nm_act === "" ? "알림" : item.nm_act}]`}</span>
                    <span className={`act-symbol ${item.position_side === 'LONG' ? 'font-color-chart-long' : 'font-color-chart-short'}`}>{item.symbol}</span>
                    <span className={`position ${item.position_side === 'LONG' ? 'long' : 'short'}`}>{item.position_side}</span>
                  </p>
                  <div className="mob-notice-img">
                    {item.yn_read === 'N' ? (
                      <Image src={NOTICE.mo.check} width={14} height={14} alt="notice check" />
                    ) : null}
                  </div>
                </dt>
                <dd>
                  <p className="font-medium">
                    {item.ttl}
                  </p>
                  <strong className="font-semibold">{formatDateTimeStringToKoreaTimeString(item.dttm_reg)}</strong>
                </dd>
              </dl>
            </button>
          </li>
        ))}
        {/*알림개수 0일때*/}
        {allNotifications.length === 0 && (
          <li className="flex flex-col items-center justify-center gap-[12px] h-[380px] pt-[16px] pb-[8px]">
            <Image src={DATA_STATUS.mo.nodata} width={64} height={64} alt="nodata" />
            <p className="text-[16px] text-font-sub"> {t('Notice.NoData')}</p>
          </li>
        )}
      </ul>
    </>
  );
}; 